import React from "react";
import { Spinner } from "reactstrap";

interface LoaderProps {
  size?: string | null;
  color?: string | null;
}

const Loader = ({ size = null, color = null }: LoaderProps) => {
  return (
    <div className="loader-container">
      <div className="status">
        {/* <Spinner color="primary" /> */}
        <Spinner color={color || undefined} size={size || undefined} />
      </div>
    </div>
  );
};

export default Loader;
